import React, { forwardRef } from 'react'
import {
  Select as ChSelect,
} from "@chakra-ui/react"
import usePrettyOptions from '../../hooks/usePrettyOptions'

const Select = forwardRef(({ children = [], control, rules, ...props }, ref) => {
  const options = usePrettyOptions(children)
  return (
    <ChSelect placeholder="請選擇" {...props} ref={ref}>
      {options.map((opt, i) => {
        return <option value={opt.value} key={i + opt.value}>{opt.label}</option>
      })}
    </ChSelect>
  )
})

Select.displayName = 'Select'

export default Select
